import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AppConfigService} from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {

  private notificationUnreadCountUrl = '/api/v1/notifications/unread/count'
  private notificationUreadUrl = '/api/v1/notifications/unread'

  constructor(private http: HttpClient) { }

  getUnreadNotificationCount(): Observable<number> {
    return this.http.get<number>(AppConfigService.notificationManagerUrl + this.notificationUnreadCountUrl);
  }
  getUnreadNotifications(): Observable<any[]> {
    return this.http.get<any[]>(AppConfigService.notificationManagerUrl + this.notificationUreadUrl);
  }

  markNotificationAsRead(notificationId: string): Observable<void> {
    return this.http.put<void>(`${AppConfigService.notificationManagerUrl}/api/v1/notifications/${notificationId}/read`, {});
  }

  markAllNotificationsAsRead(): Observable<void> {
    return this.http.put<void>(`${AppConfigService.notificationManagerUrl}/api/v1/notifications/read-all`, {});
  }


}
